module.exports = __webpack_public_path__ + "static/Principal-Regular-99f23fc2a7c945294ad13d36d6f5df59.woff2";